import dayjs from 'dayjs';
var Readable = /** @class */ (function () {
    function Readable() {
        this.readingProgress = 0; //ToDO: Make this nullable?
        this.isOwned = false;
    }
    Readable.prototype.toApi = function () {
        var _a, _b;
        return Object.assign({}, this, {
            seriesId: this.seriesId.toString(),
            releaseDate: this.releaseDate.toISOString(),
            printReleaseDate: (_a = this.printReleaseDate) === null || _a === void 0 ? void 0 : _a.toISOString(),
            digitalReleaseDate: (_b = this.digitalReleaseDate) === null || _b === void 0 ? void 0 : _b.toISOString()
        });
    };
    Readable.createFromApi = function (dto) {
        if (!dto)
            return null;
        return Object.assign(new Readable(), dto, {
            seriesId: parseInt(dto.seriesId),
            releaseDate: dayjs(dto.releaseDate),
            printReleaseDate: dto.printReleaseDate ? dayjs(dto.printReleaseDate) : null,
            digitalReleaseDate: dto.digitalReleaseDate ? dayjs(dto.digitalReleaseDate) : null,
        });
    };
    return Readable;
}());
export { Readable };
var ReadableDTO = /** @class */ (function () {
    function ReadableDTO() {
    }
    return ReadableDTO;
}());
export { ReadableDTO };
